import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField/index';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popover from '@material-ui/core/Popover';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Component styles
import styles from './styles';
import { Grid, TableRow, TableCell, Divider, Table } from '@material-ui/core';
import {api_host, api_auth} from '../../../../common/globals/constants';

import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { Alert } from '@material-ui/lab';
import TagsAtentus from '../../../../components/TagsAtentus/TagsAtentus';
import { updateEtiquetasObjetivo } from '../../../../services/tags';


const sendValues = (value, nombre, descripcion, 
                sla_disponibilidad_error, sla_disponibilidad_ok, 
                sla_rendimiento_error, sla_rendimiento_ok, 
                paso_nombre_actualizado, token, objetivo_id,
                user, admin_id) => {

    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/config_objetivo/?token=${token}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, 
                    sla_disponibilidad_error: sla_disponibilidad_error, sla_disponibilidad_ok: sla_disponibilidad_ok, 
                    sla_rendimiento_error: sla_rendimiento_error, sla_rendimiento_ok: sla_rendimiento_ok, 
                    paso_nombre_actualizado: paso_nombre_actualizado, opcion: value, user: user, admin: admin_id}), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 100);
    });
};




class ManageObjective extends Component {

    constructor(props) {
        super(props);
        var nodeId = -1
        if (Object.keys(this.props.values.nodesEdit).length > 0){
            nodeId = this.props.values.nodesEdit[0].id_nodo
        }
        this.state = {
            handleCloseEdit: this.props.handleCloseEdit,
            //handleCloseSnack: this.props.handleCloseSnack,
            handleShowSnack: this.props.handleShowSnack,
            values: this.props.values,
            intervals: this.props.intervals.intervalos,
            settingsEl: null,
            value: this.props.value,
			updateDisabled: true,
			dataError: false,
            isLoading: true,
            listObjective: this.props.listObjective,
            objetivo_id: this.props.objective,
            openSnack: false,
            isValid: false,
            validName: false,
            isInfo: false,
            valueTab: 0, 
            intervalName: "",
            valueTab2: nodeId, 
            arrayNodes: [],
            isOpenPopPattern: null,
            patterns: [],
            validNameStep: false,
            validDescription: false,
            validDispOk: false,
            validDispError: false,
            validRendOk: false,
            validRendError: false,
            valuesEdit: this.props.values,
            valuesStepEdit: [],
            profileId: sessionStorage.getItem('profile_id'),
            listDisplaySaved: [1,2,5],
            etiquetas: this.props.values?.etiquetas ?? [],
        }
    }

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.valuesEdit[field] = value;   
        this.setState(newState);
    };
    
    handleSaved = async (value) => {
        const {values, valuesEdit, valuesStepEdit} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let admin_id = sessionStorage.getItem('admin_id')
        if (Object.keys(valuesEdit).length > 0 || Object.keys(valuesStepEdit).length > 0) {
            var nombre = valuesEdit.name
            var descripcion = valuesEdit.description
            var sla_disponibilidad_error = valuesEdit.dispError
            var sla_disponibilidad_ok = valuesEdit.dispOk
            var sla_rendimiento_error = valuesEdit.rendError
            var sla_rendimiento_ok = valuesEdit.rendOk
            var paso_nombre_actualizado = valuesStepEdit
            var value = "0" 
            if (Object.keys(valuesStepEdit).length > 0){
                value = "1"
            }
            var ok = await sendValues(value, nombre, descripcion, 
                                    sla_disponibilidad_error, sla_disponibilidad_ok, 
                                    sla_rendimiento_error, sla_rendimiento_ok, paso_nombre_actualizado, 
                                    token, values.objidEdit, user, admin_id);
            
            const etiquetasId = [...new Set(this.state.etiquetas.map(item => item.etiqueta_id))]
            await updateEtiquetasObjetivo(
                {
                    objetivoId: values.objidEdit,
                    etiquetas: etiquetasId
                }
            );
            this.props.updateList()

            if (ok){
                this.setState({
                    //isLoading: true,
                    isValid: true,                   
                    openSnack: true,
                    editEl: null,
                    addEl: null,
                    validEmail: false,
                    validName: false,
                });
                //handleShowSnack(true)
                //this.getDataFromAPI();
                setTimeout(() => {
                    this.handleCloseAdd();
                }, 3000)
            } else {
                //handleShowSnack(false)
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    openSnack: true,
                });  
            }
        } else {
            //handleShowSnack(false)
            this.setState({
                isLoading: false,
                isValid: false,                   
                openSnack: true
            });
        }
    };
    
    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            openSnack: false 
        })
    };
    
    validateName = (name) => {
        if (!name) {
            this.setState({
                validName: true,
            });
        } else {
            this.setState({
                validName: false,
            });
        }
    }
    validateDescription = (description) => {
        if (!description) {
            this.setState({
                validDescription: true,
            });
        } else {
            this.setState({
                validDescription: false,
            });
        }
    }

    validateNameStep = (name, key, keyStep) => {
        const {arrayValidateStep} = this.state
        if (!name) {
            arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso] = true
            this.setState({
                arrayValidateStep: arrayValidateStep,
            });
        } else {
            arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso] = false
            this.setState({
                arrayValidateStep: arrayValidateStep,
            });
        }
    }
    validateDispOk = (dispOk) => {
        if (!dispOk) {
            this.setState({
                validDispOk: true,
            });
        } else {
            if((parseInt(dispOk) < 101 && parseInt(dispOk) > 0)){
                this.setState({
                    validDispOk: false,
                });
            } else {
                this.setState({
                    validDispOk: true,
                });
            } 
        }
    }
    validateDispError = (dispError) => {
        if (!dispError) {
            this.setState({
                validDispError: true,
            });
        } else {
            if((parseInt(dispError) < 101 && parseInt(dispError) > 0)){
                this.setState({
                    validDispError: false,
                });
            } else {
                this.setState({
                    validDispOError: true,
                });
            } 
        }
    }
    validateRendOk = (rendOk) => {
        if (!rendOk) {
            this.setState({
                validRendOk: true,
            });
        } else {
            if((parseInt(rendOk) < 101 && parseInt(rendOk) > 0)){
                this.setState({
                    validRendOk: false,
                });
            } else {
                this.setState({
                    validRendOk: true,
                });
            } 
        }
    }
    validateRendError = (rendError) => {
        if (!rendError) {
            this.setState({
                validRendError: true,
            });
        } else {
            if((parseInt(rendError) < 101 && parseInt(rendError) > 0)){
                this.setState({
                    validRendError: false,
                });
            } else {
                this.setState({
                    validRendError: true,
                });
            } 
        }
    }

    handleFieldChangeStep = (field, value) => {
        const newState = { ...this.state };
        newState.valuesStepEdit[field] = value;     
        this.setState(newState);
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };
    

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    handleChangeTab = (event, newValue) => {
        this.setState({
            valueTab: newValue,
        });
    };
    handleChangeTab2 = (event, newValue) => {
        this.setState({
            valueTab2: newValue,
        });
    };
    openPopPattern = patterns => event => {
        this.setState({
            isOpenPopPattern: event.currentTarget,
            patterns: patterns
        });
    };
    closePopPattern = event => {
        this.setState({
            isOpenPopPattern: null
        });
    };
    handleCloseAdd = (event) => {
        const{ handleCloseEdit } = this.state
        handleCloseEdit()
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
        });
    };
    static getDerivedStateFromProps(nextProps, prevState) {
        /*if (nextProps.value !== prevState.value) {
            return {
                value: nextProps.value,
                updateDisabled: true
            }
        }*/
        return null
    }
    componentDidUpdate(){
        //this.processData()
    }

    componentDidMount(){
        this.getDataFromAPI()
    }

    getDataFromAPI = (objectiveId) => {
        const {values} = this.state
        let token = sessionStorage.getItem('key')
        let objetivo_id = values.objidEdit
        let servicio_id = values.serviceidEdit
        const start = Date.now()
		Promise.all([
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/pasos_config_obj/?token=${token}&servicio=${servicio_id}&start${start}`),
            fetch(api_host+`/reporte/general/objetivos/${objetivo_id}/sla_objetivo/?token=${token}&start${start}`)
		])
			.then(([res2, res3]) => {
				return Promise.all([res2.json(), res3.json()])
			})
			.then(([res2, res3]) => {
				// Se define el state de acuerdo a la petición y respuesta de la promesa 
				if (res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
					localStorage.setItem('isAuthenticated', false);
				} else {
					//Procesa la Data Recibida
					try {					
						this.processData(res2, res3)
						/*if (this.state.lastEvent !== []) {
							this.props.params.onFirstInfo(this.state.lastEvent)
						}*/
					} catch (error) {
						this.setState({
							dataError: true,
							data: null,
							isLoading: false
						});
					}
				}
			});   
        
    }
    processData = (dataConfigStep, dataSla) => {
        const {values, intervals} = this.state
        var intervalName = ''
        if (values.intervalidEdit != null){
            Object.keys(intervals).map((key) => {
                if (values.intervalidEdit == intervals[key]['intervalo_id']){
                    intervalName = intervals[key]['nombre']
                }
            })
        }
        var arrayValidateStepNode = []
        var arrayNode = []
        Object.keys(values.nodesEdit).map((keyNode) => {
            if (values.nodesEdit[keyNode].id_nodo != 0){
                var dictNode = {}
                var dictValidateStepNode = {}
                dictNode['id_nodo'] = values.nodesEdit[keyNode].id_nodo
                dictNode['monitor_id'] = values.nodesEdit[keyNode].monitor
                dictNode['nombre_nodo'] = values.nodesEdit[keyNode].nodo
                dictValidateStepNode['id_nodo'] = values.nodesEdit[keyNode].id_nodo
                var arrayStep = []
                var arrayValidateStep = []
                Object.keys(values.stepEdit).map((keyStep) => {
                    var dictStep = {}
                    var dictValidateStep = {}
                    dictStep['id_paso'] = values.stepEdit[keyStep].id_paso
                    dictStep['nombre_paso'] = values.stepEdit[keyStep].nombre_paso
                    dictValidateStep[values.stepEdit[keyStep].id_paso] = false
                    dictValidateStep['id_paso'] = values.stepEdit[keyStep].id_paso
                    Object.keys(dataConfigStep).map((keyConfig) => {
                        if (parseInt(values.stepEdit[keyStep].id_paso) == dataConfigStep[keyConfig].paso_orden){
                            dictStep['timeout'] = dataConfigStep[keyConfig].timeout
                            dictStep['patrones'] = dataConfigStep[keyConfig].patrones
                            dictStep['cantidadPatrones'] = dataConfigStep[keyConfig].patrones.length
                            if (values.serviceidEdit == 666){
                                if (dataConfigStep[keyConfig].numero_llamada){
                                    Object.keys(dataConfigStep[keyConfig].numero_llamada).map((keyCall) => { 
                                        if (dataConfigStep[keyConfig].numero_llamada[keyCall].monitor_id == "0" 
                                            || dataConfigStep[keyConfig].numero_llamada[keyCall].monitor_id == values.nodesEdit[keyNode].monitor.toString()){
                                                dictStep['numero_llamada'] = dataConfigStep[keyConfig].numero_llamada[keyCall].valor
                                            }
                                    })
                                } else {
                                    dictStep['numero_llamada'] = "N/A"
                                }
                                if (dataConfigStep[keyConfig].timeouts){
                                    Object.keys(dataConfigStep[keyConfig].timeouts).map((keyTime) => { 
                                        if (dataConfigStep[keyConfig].timeouts[keyTime].monitor_id == "0" 
                                            || dataConfigStep[keyConfig].timeouts[keyTime].monitor_id == values.nodesEdit[keyNode].monitor.toString()){
                                                dictStep['timeout'] = dataConfigStep[keyConfig].timeouts[keyTime].valor
                                            }
                                    })
                                } else {
                                    dictStep['timeout'] = "N/A"
                                }
                                if (dataConfigStep[keyConfig].dtmf){
                                    Object.keys(dataConfigStep[keyConfig].dtmf).map((keyDtmf) => { 
                                        if (dataConfigStep[keyConfig].dtmf[keyDtmf].monitor_id == "0" 
                                            || dataConfigStep[keyConfig].dtmf[keyDtmf].monitor_id == values.nodesEdit[keyNode].monitor.toString()){
                                                dictStep['dtmf'] = dataConfigStep[keyConfig].dtmf[keyDtmf].valor
                                            }
                                    })
                                } else {
                                    dictStep['dtmf'] = "N/A"
                                }
                                if (dataConfigStep[keyConfig].audio){
                                    Object.keys(dataConfigStep[keyConfig].audio).map((keyAudio) => { 
                                        if (dataConfigStep[keyConfig].audio[keyAudio].monitor_id == "0" 
                                            || dataConfigStep[keyConfig].audio[keyAudio].monitor_id == values.nodesEdit[keyNode].monitor.toString()){
                                                dictStep['audio'] = dataConfigStep[keyConfig].audio[keyAudio].valor
                                            }
                                    })
                                } else {
                                    dictStep['audio'] = "N/A"
                                }
                                
                            } else {
                                Object.keys(dataConfigStep[keyConfig].url).map((keyUrl) => { 
                                    if (dataConfigStep[keyConfig].url[keyUrl].monitor_id == "0" 
                                        || dataConfigStep[keyConfig].url[keyUrl].monitor_id == values.nodesEdit[keyNode].monitor.toString()){
                                        if (dataConfigStep[keyConfig].url[keyUrl].valor == ""){
                                            dictStep['valor'] = "N/A"
                                            dictStep['metodo'] = "POST"
                                        } else {
                                            dictStep['valor'] = dataConfigStep[keyConfig].url[keyUrl].valor 
                                            dictStep['metodo'] = "GET"
                                        }
                                    }
                                })
                            }
                        }
                    })
                    arrayStep.push(dictStep)
                    arrayValidateStep.push(dictValidateStep)
                })
                dictValidateStepNode['pasos'] = arrayValidateStep
                dictNode['pasos'] = arrayStep
                arrayNode.push(dictNode)
                arrayValidateStepNode.push(dictValidateStepNode)
            }
        })
        this.setState({
            intervalName: intervalName,
            isLoading: false,
            dispOk: dataSla.sla_disponibilidad_ok,
            dispError: dataSla.sla_disponibilidad_error,
            rendOk: dataSla.sla_rendimiento_ok,
            rendError: dataSla.sla_rendimiento_error,
            arrayNodes: arrayNode,
            arrayValidateStep: arrayValidateStepNode
        })
        
    }

    checkSlaDisponibilidad = () => {
        const {dispOk, dispError, valuesEdit: {dispOk: dispOkEdit, dispError: dispErrorEdit}} = this.state
        const ok = dispOkEdit ?? dispOk
        const error = dispErrorEdit ?? dispError
        return ok && error && parseFloat(ok) >= parseFloat(error)
    }

    checkSlaRendimiento = () => {
        const {rendOk, rendError, valuesEdit: {rendOk: rendOkEdit, rendError: rendErrorEdit}} = this.state
        const ok = rendOkEdit ?? rendOk
        const error = rendErrorEdit ?? rendError
        return ok && error && parseFloat(ok) <= parseFloat(error)
    }

    updateEtiquetas = (nuevasEtiquetas) => {
        this.setState({etiquetas: nuevasEtiquetas})
    }

    preventPaste = (e) => {
        e.preventDefault();
        return false;
    }

    render() {
        const { classes, className, alertobjectives, t, ...rest } = this.props;
        const { isLoading, validName, values, isInfo, valueTab, intervalName,
            dispOk, dispError, rendOk, rendError, valueTab2, arrayNodes, isOpenPopPattern, patterns,
            validDescription, validDispOk, validDispError, validRendOk, validRendError, 
            arrayValidateStep, openSnack, isValid, listDisplaySaved, profileId} = this.state;
        const showIsInfo = Boolean(isInfo);
        const showPopPattern = Boolean(isOpenPopPattern);
        const rootClassName = classNames(classes.root, className);
        var displaySaved = false
        if(listDisplaySaved.includes(parseInt(profileId)) === true){
            displaySaved = true
        }
        return ( isLoading ? 
            <PortletContent>
                    <Typography
                    variant="h5"
                    algin="center"
                    >
                    <CircularProgress
                    variant="indeterminate"
                    size={24}
                    thickness={4}
                    />
                    <br/>
                        {t('text.loading')}
                    </Typography>
            </PortletContent>
            : 
            <Portlet
                {...rest}
                className={rootClassName}
            >
                    <PortletHeader className={classes.porletHeaderExt} >
                    <PortletLabel
                        title={t('manageObjective.title')}
                        style={{color:'white'}}
                    />
                    <div>
                        <IconButton
                        onClick={this.handleShowIsInfo}
                        >
                            <HelpOutlineOutlinedIcon style={{color:"white"}}/>
                        </IconButton>
                        <IconButton style={{color:"white", float:"right"}} onClick={this.handleCloseAdd}><CloseIcon/></IconButton>
                    </div>
                    <Popover
                        anchorEl={isInfo}
                        open={showIsInfo}
                        onClose={this.handleCloseIsInfo}
                        className={classes.popover}
                        >
                        <PortletContent className={classes.popoverPorlet}>
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.title')}
                            </Typography> 
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.p1')}
                            </Typography> 
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.p2')}
                            </Typography> 
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.p3')}
                            </Typography> 
                        </PortletContent>
                        
                        <Divider/>
                        <PortletContent className={classes.popoverPorlet}>
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.configureByMonitorTitle')}
                            </Typography> 
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.monitorP1')}
                            </Typography> 
                            <Typography variant="body1" className={classes.textColorPopover} >
                                {t('manageObjective.info.monitorP2')}
                            </Typography> 
                        </PortletContent>
                    </Popover>
                </PortletHeader>
                <PortletContent className={classes.porletContentExt}>
                    <AppBar position="static" style={{ backgroundColor: '#525252'}}>
                        <Tabs value={valueTab} onChange={this.handleChangeTab} aria-label="simple tabs example">
                            <Tab label={t('manageObjective.tabs.info')}  />
                            <Tab label={t('manageObjective.tabs.configureByMonitor')} /*disabled={!updateDisabled}*//>
                        </Tabs>
                    </AppBar>
                    { valueTab == 0 ?                     
                        <PortletContent style={{padding: 10}}>
                            <form className={classes.form}>
                                <div className={classes.group}>                        
                                    <TextField
                                        className={classes.textField}
                                        label={t('manageObjective.fields.name')}
                                        name="name"
                                        onChange={event =>
                                            this.handleFieldChange('name', event.target.value)
                                        }
                                        type="text"
                                        required
                                        onBlur={event =>
                                            this.validateName(event.target.value)
                                        }
                                        defaultValue={values.nameEdit}
                                        error={validName}
                                        helperText={validName ? t('manageObjective.validation.name') : ''}
                                        variant="outlined"
                                        inputProps={{maxLength :40}}
                                    />
                                    <TextField
                                        className={classes.textField}
                                        label={t('manageObjective.fields.description')}
                                        name="description"
                                        onChange={event =>
                                            this.handleFieldChange('description', event.target.value)
                                        }
                                        type="text"
                                        required
                                        onBlur={event =>
                                            this.validateDescription(event.target.value)
                                        }
                                        defaultValue={values.descriptionEdit}
                                        error={validDescription}
                                        helperText={validDescription ? t('manageObjective.validation.description') : ''}
                                        variant="outlined"
                                        inputProps={{maxLength :40}}
                                    />
                                    <TextField
                                        className={classes.textField}
                                        label={t('manageObjective.fields.service')}
                                        name="service"
                                        type="text"
                                        value={values.serviceEdit}
                                        variant="outlined"
                                        disabled={true}
                                        InputProps={{
                                            classes:{
                                                root: classes.inputRoot,
                                                disabled: classes.disabled
                                            }
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.labelRoot,
                                                disabled: classes.disabled
                                            }
                                        }}
                                    />
                                    <TextField
                                        className={classes.textField}
                                        label={t('manageObjective.fields.interval')}
                                        name="interval"
                                        type="text"
                                        value={intervalName}
                                        variant="outlined"
                                        disabled={true}
                                        InputProps={{
                                            classes:{
                                                root: classes.inputRoot,
                                                disabled: classes.disabled
                                            }
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.labelRoot,
                                                disabled: classes.disabled
                                            }
                                        }}
                                    />
                                    <Divider />
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            paddingTop: 10,
                                            paddingBottom: 10,
                                            flex: 1
                                        }}>
                                            <div style={{marginBottom: 5}}>
                                                        <Typography variant='body1'>
                                                            {t('manageObjective.labels.tags')}
                                                        </Typography>
                                            </div>
                                            <div>
                                                <TagsAtentus
                                                    updateEtiquetas={(etiquetas) => this.updateEtiquetas(etiquetas)}
                                                    etiquetas={this.state.etiquetas}
                                                    showFilterType={false}
                                                />
                                            </div>
                                        </div>
                                    <Divider />
                                    <Grid
                                        container
                                        style={{marginTop: 30}}
                                        spacing={2}
                                    >    
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            xl={4}
                                            style={{marginTop: "10px", marginBottom: 10}}>
                                                <label style={{marginLeft: "10px", fontSize: 15, fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>{t('manageObjective.sla.disponibilidad.title')}</label>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            xl={4}>
                                                <TextField
                                                className={classes.textFieldSLA}
                                                label={t('manageObjective.sla.ok')}
                                                name="dispOk"
                                                onChange={event =>
                                                    this.handleFieldChange('dispOk', event.target.value)
                                                }
                                                type="number"
                                                //required
                                                onBlur={event =>
                                                    this.validateDispOk(event.target.value)
                                                }
                                                defaultValue={dispOk}
                                                error={validDispOk}
                                                helperText={validDispOk ? 'Por favor ingrese un valor válido' : ' '}
                                                variant="outlined"
                                                inputProps={{maxLength :3, min: 0, max: 100}}
                                                fullWidth
                                                onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
                                                onPaste={this.preventPaste}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            xl={4}>
                                                <TextField
                                                className={classes.textFieldSLA}
                                                label={t('manageObjective.sla.error')}
                                                name="dispError"
                                                onChange={event =>
                                                    this.handleFieldChange('dispError', event.target.value)
                                                }
                                                type="number"
                                                //required
                                                onBlur={event =>
                                                    this.validateDispError(event.target.value)
                                                }
                                                defaultValue={dispError}
                                                error={validDispError}
                                                helperText={validDispError ? t('manageObjective.validation.value') : ' '}
                                                variant="outlined"
                                                inputProps={{maxLength :3, min: 0, max: 100}}
                                                fullWidth
                                                onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
                                                onPaste={this.preventPaste}
                                            />
                                        </Grid>
                                        {!this.checkSlaDisponibilidad() &&
                                            <Grid item xs={12} sm={12} md={12} xl={12} style={{marginBottom: 20}}>
                                                <Alert severity='error'>
                                                    {t('manageObjective.validation.dispComparison')}
                                                </Alert>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                    >    
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            xl={4}
                                            style={{marginTop: "10px", marginBottom: 10}}>
                                                <label style={{marginLeft: "10px", fontSize: 15, fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>{t('manageObjective.sla.rendimiento.title')}</label>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            xl={4}>
                                            <TextField
                                                className={classes.textFieldSLA}
                                                label={t('manageObjective.sla.ok')}
                                                name="rendOk"
                                                onChange={event =>
                                                    this.handleFieldChange('rendOk', event.target.value)
                                                }
                                                type="number"
                                                //required
                                                onBlur={event =>
                                                    this.validateRendOk(event.target.value)
                                                }
                                                defaultValue={rendOk}
                                                error={validRendOk}
                                                helperText={validRendOk ? t('manageObjective.validation.value') : ' '}
                                                variant="outlined"
                                                inputProps={{maxLength :3, min: 0, max: 100}}
                                                onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
                                                onPaste={this.preventPaste}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            xl={4}>
                                            <TextField
                                                className={classes.textFieldSLA}
                                                label={t('manageObjective.sla.error')}
                                                name="rendError"
                                                onChange={event =>
                                                    this.handleFieldChange('rendError', event.target.value)
                                                }
                                                type="number"
                                                //required
                                                onBlur={event =>
                                                    this.validateRendError(event.target.value)
                                                }
                                                defaultValue={rendError}
                                                error={validRendError}
                                                helperText={validRendError ? t('manageObjective.validation.value') : ' '}
                                                variant="outlined"
                                                inputProps={{maxLength :3, min: 0, max: 100}}
                                                onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
                                                onPaste={this.preventPaste}
                                            />
                                        </Grid>
                                        {!this.checkSlaRendimiento() &&
                                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                                <Alert severity='error'>
                                                    {t('manageObjective.validation.rendComparison')}
                                                </Alert>
                                            </Grid>
                                        }
                                    </Grid>
                                    
                                </div>
                            </form>
                        </PortletContent>
                    : valueTab == 1 ?   
                        valueTab2 == -1 ?
                        <Typography variant="body1" className={classes.typography} >{t('manageObjective.noMonitorAssociated')}</Typography>
                        :
                        <PortletContent 
                            style={{padding: 15}}>
                            <Tabs style={{width:'100%'}} /*orientation="vertical"*/ variant="scrollable" value={valueTab2} onChange={this.handleChangeTab2} aria-label="simple tabs example">
                                {Object.keys(values.nodesEdit).map((key) => { 
                                    if (values.nodesEdit[key].id_nodo != 0){
                                       return <Tab label={values.nodesEdit[key].nodo} value={values.nodesEdit[key].id_nodo}  />
                                    }
                                })}
                            </Tabs>
                            
                            {values.serviceidEdit == 666 ? 
                                <Table>
                                        <TableRow>
                                        <TableCell>{t('manageObjective.table.nombre')}</TableCell>
                                        <TableCell>{t('manageObjective.table.audio')}</TableCell>
                                        <TableCell>{t('manageObjective.table.timeout')}</TableCell>
                                        <TableCell>{t('manageObjective.table.dtmf')}</TableCell>
                                        <TableCell>{t('manageObjective.table.numeroLlamadas')}</TableCell>
                                    </TableRow>
                                    {Object.keys(arrayNodes).map((key) => { 
                                        if (valueTab2 == arrayNodes[key].id_nodo){
                                            return Object.keys(arrayNodes[key].pasos).map((keyStep) => { 
                                                return  <TableRow>
                                                            <TableCell style={{minWidth:'150px'}}>
                                                                <TextField
                                                                    className={classes.textField}
                                                                    //label="NombrePaso"
                                                                    name="nameStep"
                                                                    onChange={event =>
                                                                        this.handleFieldChangeStep(arrayNodes[key].pasos[keyStep].id_paso, event.target.value)
                                                                    }
                                                                    type="text"
                                                                    required
                                                                    onBlur={event =>
                                                                        this.validateNameStep(event.target.value, key, keyStep)
                                                                    }
                                                                    defaultValue={arrayNodes[key].pasos[keyStep].nombre_paso}
                                                                    error={arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso]}
                                                                    helperText={arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso] ? t('manageObjective.validation.name') : ' '}
                                                                    variant="outlined"
                                                                    inputProps={{maxLength :40}}
                                                                /></TableCell>
                                                            <TableCell>{arrayNodes[key].pasos[keyStep].audio} </TableCell>
                                                            <TableCell>{arrayNodes[key].pasos[keyStep].timeout} </TableCell>
                                                            <TableCell>{arrayNodes[key].pasos[keyStep].dtmf}  </TableCell>
                                                            <TableCell>{arrayNodes[key].pasos[keyStep].numero_llamada}</TableCell>
                                                        </TableRow>
                                                        
                                            })
                                            
                                        }
                                    })}
                                </Table>
                            :
                            <Table >
                                    <TableRow>
                                    <TableCell>{t('manageObjective.table.nombre')}</TableCell>
                                    <TableCell>{t('manageObjective.table.paso')}</TableCell>
                                    <TableCell>{t('manageObjective.table.timeout')}</TableCell>
                                    <TableCell>{t('manageObjective.table.metodo')}</TableCell>
                                    <TableCell>{t('manageObjective.table.pattern')}</TableCell>
                                </TableRow>
                                {Object.keys(arrayNodes).map((key) => { 
                                    if (valueTab2 == arrayNodes[key].id_nodo){
                                        return Object.keys(arrayNodes[key].pasos).map((keyStep) => { 
                                            return  <TableRow>
                                                        <TableCell style={{minWidth:'150px'}}>
                                                            <TextField
                                                                className={classes.textField}
                                                                //label="NombrePaso"
                                                                name="nameStep"
                                                                onChange={event =>
                                                                    this.handleFieldChangeStep(arrayNodes[key].pasos[keyStep].id_paso, event.target.value)
                                                                }
                                                                type="text"
                                                                required
                                                                onBlur={event =>
                                                                    this.validateNameStep(event.target.value, key, keyStep)
                                                                }
                                                                defaultValue={arrayNodes[key].pasos[keyStep].nombre_paso}
                                                                error={arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso]}
                                                                helperText={arrayValidateStep[key].pasos[keyStep][arrayValidateStep[key].pasos[keyStep].id_paso] ? t('manageObjective.validation.name') : ' '}
                                                                variant="outlined"
                                                                inputProps={{maxLength :40}}
                                                            /></TableCell>
                                                                                <TableCell>
                                                                            { arrayNodes[key].pasos[keyStep].valor !== null ? (
                                                                             arrayNodes[key]?.pasos[keyStep]?.valor?.length > 4 ? (
                                                                             <Tooltip title={arrayNodes[key].pasos[keyStep].valor}>
                                                                                <Link target="_blank" 
                                                                                href={arrayNodes[key].pasos[keyStep].valor} rel="noreferrer">
                                                                                {t('manageObjective.link.viewUrl')}
                                                                                </Link>
                                                                                </Tooltip>
                                                                            ):( <typography>{arrayNodes[key].pasos[keyStep].valor}</typography>)) :
                                                                            ( <typography>{arrayNodes[key].pasos[keyStep].valor}</typography>)
                                                                            }
                                                                            </TableCell>
                                                        <TableCell>{arrayNodes[key].pasos[keyStep].timeout} </TableCell>
                                                        <TableCell>{arrayNodes[key].pasos[keyStep].metodo}  </TableCell>
                                                        <TableCell><Button onClick={this.openPopPattern(arrayNodes[key].pasos[keyStep].patrones)}>{arrayNodes[key].pasos[keyStep].cantidadPatrones}</Button></TableCell>
                                                    </TableRow>
                                                    
                                        })
                                        
                                    }
                                })}
                                <Popover
                                    anchorEl={isOpenPopPattern}
                                    open={showPopPattern}
                                    onClose={this.closePopPattern}
                                    className={classes.popover}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right',
                                    }}
                                    >
                                        <Table>
                                        <TableRow>
                                            <TableCell>{t('manageObjective.patterns.nombre')}</TableCell>
                                            <TableCell>{t('manageObjective.patterns.valor')}</TableCell>
                                            <TableCell>{t('manageObjective.patterns.tipo')}</TableCell>
                                            <TableCell>{t('manageObjective.patterns.inverso')}</TableCell>
                                            <TableCell>{t('manageObjective.patterns.opcional')}</TableCell>
                                        </TableRow>
                                        {Object.keys(patterns).map((key) => { 
                                        return<TableRow>
                                                <TableCell>{patterns[key]['@nombre']}</TableCell>
                                                <TableCell>{patterns[key]['#text']? patterns[key]['#text'].substr(0,19) : patterns[key]['@valor'].substr(0,19) }</TableCell>
                                                <TableCell>{patterns[key]['@tipo']}</TableCell>
                                                <TableCell>{patterns[key]['@es_inverso']}</TableCell>
                                                <TableCell>{patterns[key]['@es_opcional']}</TableCell>
                                        </TableRow>
                                        })}
                                   
                                    </Table>
                                </Popover>
                            </Table>
                            }
                            
                        </PortletContent>
                    
                    : null}
                </PortletContent>
                <PortletFooter align="right">
                    {displaySaved ?<Button
                        color="primary"
                        variant="contained"
                        onClick={this.handleSaved}
                    >
                        {t('text.save')}
                    </Button>:null}
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={this.handleCloseAdd}
                        style={{marginLeft: 10}}
                    >
                        {t('manageObjective.button.cancel')}
                    </Button>
                </PortletFooter>
                <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={openSnack}
                        autoHideDuration={6000}
                        onClose={this.handleCloseSnack}
                        >
                            <SnackbarContent
                                className={isValid ? classes.snackContentOk
                                            : classes.snackContent}
                                aria-describedby="client-snackbar"
                                message={
                                    isValid ?
                                            <div id="client-snackbar" className={classes.message}>
                                                <CheckCircleIcon className={(classes.icon, classes.iconVariant)}/>
                                                {t('manageObjective.snackbar.success')}
                                            </div>
                                        :	<div id="client-snackbar" className={classes.message}>
                                                <ErrorIcon className={(classes.icon, classes.iconVariant)}/>
                                                {t('manageObjective.snackbar.error')}
                                            </div>
                                }
                                action={[
                                    <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleCloseSnack}>
                                        <CloseIcon className={classes.icon}/>
                                    </IconButton>
                                ]}
                            />
                    </Snackbar>
            </Portlet>
            
        );
    }
}

ManageObjective.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(ManageObjective));